import { Scene } from "onearm";

export class PreloaderScene extends Scene {
    create() {
        this.layout = this.buildLayout("PreloaderScene");
        this.progressBar = this.layout.find("LoaderProgressBar");
    }

    setProgress(progress) {
        if (this.progressBar) {
            this.progressBar.progress = progress;
        }
    }
}
